import { render, staticRenderFns } from "./About-us.vue?vue&type=template&id=019b95ea&scoped=true&"
var script = {}
import style0 from "./About-us.vue?vue&type=style&index=0&id=019b95ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019b95ea",
  null
  
)

export default component.exports